import { forwardRef } from "react";
import classNames from "classnames";
import { Card } from "antd";
import type { CardProps } from "antd";
import styles from "./styles.module.css";

type Props = CardProps;

export const AppCard = forwardRef<HTMLDivElement, Props>(({ className, ...props }, ref) => {
  return <Card ref={ref} className={classNames(styles.card, className)} {...props} />;
});
